import { useMutation } from '@tanstack/react-query';
import { AlternativeAlgorithmSetsSchema } from '../schema/AlternativeAlgorithmFormSchema';
import { apiClient, ApiErrorResponse } from '../../common/ApiClient';
import { DataObjectDescriptionVersionUrl } from './DataObjectDescriptionVersionUrl';
import { RcFile } from 'antd/es/upload';
import { AlternativeAlgorithmSetDataType } from '../schema';
import { expand } from 'uri-template-lite';

interface IArgs {
  file: string | Blob | RcFile;
  id?: number;
}

export const useMutateAlternativesUpload = (
  onProgress?: (progress: number) => void,
) =>
  useMutation<AlternativeAlgorithmSetDataType[], ApiErrorResponse, IArgs>({
    mutationKey: ['alternativesUpload'],
    mutationFn: async ({ file, id }) =>
      apiClient
        .post(
          expand(DataObjectDescriptionVersionUrl.uploadAlternatives, { id }),
          {
            file,
          },
          {
            headers: { 'content-type': 'multipart/form-data' },
            onUploadProgress: (progress) => {
              if (!progress.total) {
                return;
              }
              onProgress?.((progress.loaded / progress.total) * 100);
            },
          },
        )
        .then((response) =>
          AlternativeAlgorithmSetsSchema.parse(response.data),
        ),
  });
